<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap pa-3>
      <v-flex lg4 sm12 py-0>
        <v-autocomplete
          v-if="currentItem.ID == 0"
          label="Mã bao hàng"
          class="input-group--focused pt-0"
          :items="packages"
          v-model="currentItem.ID"
          item-text="PackageCode"
          item-value="ID"
          :disabled="readOnly"
          :rules="[(v) => !!v || 'Hãy nhập mã bao hàng']"
          @change="onChangePackage"
        >
        <template slot="no-data">
          <div>Không có dữ liệu bao hàng nhập kho</div>
        </template>
        </v-autocomplete>
        <v-text-field
          v-if="currentItem.ID > 0"
          label="Mã bao hàng"
          v-model="currentItem.PackageCode"
          class="input-group--focused pt-0"
          readonly
        ></v-text-field>
      </v-flex>
      <v-flex lg8 sm12 py-0>
      </v-flex>
      <v-flex lg4 sm12 py-0>
        <v-text-field
          label="Ngày nhập kho"
          :value="currentItem.ImDate | display_date"
          class="input-group--focused font-weight-bold"
          readonly
        ></v-text-field>
      </v-flex>
      <v-flex lg4 sm12  py-0>
        <h-currency-input
          label="Tổng phí ship"
          v-model="currentItem.Amount"
          :decimal="0"
          class="input-group--focused"
          readonly
        ></h-currency-input>
      </v-flex>
      <v-flex lg4 sm12  py-0>
      </v-flex>
      <v-flex lg4 sm12  py-0>
        <h-currency-input
          label="Số kiện (TQ)"
          v-model="currentItem.NumberOfPack"
          :decimal="0"
          class="input-group--focused"
          readonly
        ></h-currency-input>
      </v-flex>
      <v-flex lg4 sm12 py-0>
        <h-currency-input
          label="Số kiện đã nhập"
          v-model="currentItem.ReceivedPacks"
          :decimal="0"
          showClass="input-group--focused font-weight-bold text-red"
          color="red darken-2"
          readonly
        ></h-currency-input>
      </v-flex>
      <v-flex lg4 sm12 py-0>
      </v-flex>
      <v-flex lg4 sm12 py-0>
        <v-text-field
          label="Tổng cân nặng (TQ)"
          type="number"
          v-model="currentItem.Weight"
          class="input-group--focused"
          readonly
        ></v-text-field>
      </v-flex>
      <v-flex lg4 sm12 py-0>
        <v-text-field
          label="Tổng cân nặng đã nhập"
          type="number"
          v-model="currentItem.ReceivedWeight"
          class="input-group--focused font-weight-bold text-red"
          readonly
        ></v-text-field>
      </v-flex>
      <v-flex lg4 sm12 py-0>
      </v-flex>
      <v-flex lg8 sm12 py-0>
        <v-text-field
          label="Cân nặng thực tế"
          type="number"
          step=".1"
          v-model="currentItem.RealWeight"
          class="input-group--focused font-weight-bold"
          @change="saveData"
        ></v-text-field>
      </v-flex>
      <v-flex lg6 md6 sm12 py-0>
        <v-checkbox label="Sử dụng máy đọc barcode" v-model="useBarcodeReader"></v-checkbox>
      </v-flex>
      <v-flex lg6 md6 sm12 py-0>
        <v-checkbox label="Nhập kho VN" v-model="markStorage"></v-checkbox>
      </v-flex>
      <v-flex lg12 md12 sm12 py-0>
        <v-text-field
          label="Mã vận đơn"
          ref="trancode"
          v-model.lazy="transactionCode"
          class="input-group--focused pt-0"
          @input="codeChanged"
          @keyup.enter="manualChanged"
          :disabled="readOnly"
        ></v-text-field>
      </v-flex>
      <v-flex lg12 md12 sm12 pa-0>
        <v-data-table
          :headers="headers"
          :items="currentItem.Packages"
          :options.sync="pagination"
          :server-items-length="currentItem.Packages ? currentItem.Packages.length : 0"
          :footer-props="items_per_page"
          :must-sort="true"
          :loading="loading"
          :mobile-breakpoint="100"
        >
          <template v-slot:item="{ item }">
            <tr>
              <td v-bind:class="item.OrderID == null ? 'text-red' : ''">{{ item.TransactionCode }}</td>
              <td class="text-end">{{ item.FeeShip | currency}}</td>
              <td>{{ item.OrderID ? (item.PackageType === 1 ? 'KG' : 'MD') + item.OrderID : '' }}</td>
              <td>{{ item.Username }}</td>
              <td v-bind:style="{'color': display_color(item.Status, package_status)}">{{ item.Status | display_value(package_status) }}</td>
              <td class="text-end" v-if="item.Status == 5">{{ item.Weight}}</td>
              <td class="text-end" v-if="item.Status != 5">
                <v-edit-dialog
                  :return-value.sync="item.Weight"
                  large
                  lazy
                  persistent
                  @save="saveTranWeight(item)"
                >
                  <div>{{ item.Weight}}</div>
                  <template v-slot:input>
                    <v-text-field
                      v-model="item.Weight"
                      type="number"
                      label="Cân nặng"
                      step=".1"
                      single-line
                      autofocus
                    ></v-text-field>
                  </template>
                </v-edit-dialog>
              </td>
              <td class="text-end" v-if="item.Status == 5">{{ item.RealNumberOfPack}}</td>
              <td class="text-end" v-if="item.Status != 5">
                <v-edit-dialog
                  :return-value.sync="item.RealNumberOfPack"
                  large
                  lazy
                  persistent
                  @save="saveTranWeight(item)"
                >
                  <div>{{ item.RealNumberOfPack}}</div>
                  <template v-slot:input>
                    <v-text-field
                      v-model="item.RealNumberOfPack"
                      type="number"
                      label="Số kiện"
                      single-line
                      autofocus
                    ></v-text-field>
                  </template>
                </v-edit-dialog>
              </td>
              <td class="text-end" v-if="item.Status == 5">{{ item.Length | currency('', 1)}}</td>
              <td class="text-end" v-if="item.Status != 5">
                <v-edit-dialog
                  :return-value.sync="item.Length"
                  large
                  lazy
                  persistent
                  @save="saveTranWeight(item)"
                >
                  <div>{{ item.Length | currency('', 1)}}</div>
                  <template v-slot:input>
                    <h-currency-input
                      label="Chiều dài (cm)"
                      :decimal="1"
                      v-model="item.Length"
                      single-line
                      autofocus
                    ></h-currency-input>
                  </template>
                </v-edit-dialog>
              </td>
              <td class="text-end" v-if="item.Status == 5">{{ item.Width | currency('', 1)}}</td>
              <td class="text-end" v-if="item.Status != 5">
                <v-edit-dialog
                  :return-value.sync="item.Width"
                  large
                  lazy
                  persistent
                  @save="saveTranWeight(item)"
                >
                  <div>{{ item.Width | currency('', 1)}}</div>
                  <template v-slot:input>
                    <h-currency-input
                      label="Chiều rộng (cm)"
                      :decimal="1"
                      v-model="item.Width"
                      single-line
                      autofocus
                    ></h-currency-input>
                  </template>
                </v-edit-dialog>
              </td>
              <td class="text-end" v-if="item.Status == 5">{{ item.Height | currency('', 1)}}</td>
              <td class="text-end" v-if="item.Status != 5">
                <v-edit-dialog
                  :return-value.sync="item.Height"
                  large
                  lazy
                  persistent
                  @save="saveTranWeight(item)"
                >
                  <div>{{ item.Height | currency('', 1)}}</div>
                  <template v-slot:input>
                    <h-currency-input
                      label="Chiều cao (cm)"
                      :decimal="1"
                      v-model="item.Height"
                      single-line
                      autofocus
                    ></h-currency-input>
                  </template>
                </v-edit-dialog>
              </td>
              <td class="text-end" v-if="item.Status == 5">{{ item.Volume | currency('', 2)}}</td>
              <td class="text-end" v-else>
                <v-edit-dialog
                  :return-value.sync="item.Volume"
                  large
                  lazy
                  persistent
                  @save="saveTranWeight(item)"
                >
                  <div>{{ item.Volume | currency('', 2) }}</div>
                  <template v-slot:input>
                    <h-currency-input
                      label="Thể tích"
                      :decimal="2"
                      v-model="item.Volume"
                      single-line
                      autofocus
                    ></h-currency-input>
                  </template>
                </v-edit-dialog>
              </td>
              <!-- <td class="text-end">{{ item.WeightByVolume}}</td> -->
              <td class="truncate">
                <v-edit-dialog
                :return-value.sync="item.StoreVNNote"
                large
                lazy
                persistent
                @save="saveNoteItem(item)"
                >
                    <v-tooltip max-width="250" color="light-green lighten-5 black--text">
                        <template v-slot:activator="{ on }">
                            <span v-on="on">{{ item.StoreVNNote }}</span>
                        </template>
                        <span>{{ item.StoreVNNote }}</span>
                    </v-tooltip>
                    <template v-slot:input>
                        <v-textarea
                        v-model="item.StoreVNNote"
                        label="Ghi chú"
                        autofocus
                        ></v-textarea>
                    </template>
                </v-edit-dialog>
              </td>
              <td class="text-center">
                <v-icon medium class="mr-2" color="red darken-2" @click="printTransaction(item.ID, item.PackageType)">fa-print</v-icon>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
    <v-overlay :value="appLoading" z-index="999999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
     <v-dialog v-model="showDialogTrancode" max-width="300px">
      <v-card>
        <v-card-title>
          <span class="title">Mã vận đơn</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md pa-0>
            <v-layout row wrap>
              <v-flex lg12>
                <v-text-field label="Mã vận đơn" v-model="newTransactionCode" @change="saveNewTrancode(false)"></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1 white--text" @click="showDialogTrancode = false">Đóng</v-btn>
          <v-btn color="red darken-1 white--text" @click="saveNewTrancode">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import configs from "../../configs";
import _ from "lodash";
import { print_transaction_v2, request_detail } from "@/commons/hpod";
import Vue from 'vue';
import { getCurrentTime } from "@/commons/utils";
export default {
  data() {
    let dataType = configs.DATA_TYPE;
    let configPaging = _.cloneDeep(configs.PAGINATION);
    configPaging.itemsPerPage = 20;
    
    return {
      appLoading: false,
      useBarcodeReader: true,
      markStorage: false,
      transactionCode: "",
      headers: [
        {
          text: "Mã vận đơn",
          value: "TransactionCode",
          filterable: true,
          quickSearch: true,
          dataType: dataType["String"]
        },
        {
          text: "Phí ship",
          value: "FeeShip",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Order ID",
          value: "OrderID",
          quickSearch: true,
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Khách hàng",
          value: "Username",
          quickSearch: true,
          filterable: true,
          dataType: dataType["String"]
        },
        {
          text: "Trạng thái",
          value: "Status",
          filterable: true,
          values: configs.PACKAGE_STATUS,
          dataType: dataType["Enum"]
        },
        {
          text: "Cân nặng",
          value: "Weight",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Số kiện",
          value: "RealNumberOfPack",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Chiều dài (cm)",
          value: "Length",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Chiều rộng (cm)",
          value: "Width",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Chiều cao (cm)",
          value: "Width",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Khối",
          value: "Volume",
          filterable: true,
          dataType: dataType["Number"]
        },
        // {
        //   text: "Cân quy đổi",
        //   value: "WeightByVolume",
        //   filterable: true,
        //   dataType: dataType["Number"]
        // },
        {
          text: "Ghi chú",
          value: "StoreVNNote",
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: "Thao tác",
          value: "",
          align: "center",
          sortable: false,
          filterable: false
        }
      ],
      requireRules: [v => !!v || "Trường dữ liệu không được để trống."],
      pagination: configPaging,
      items_per_page: { "items-per-page-options": [20, 30, 50] },
      currentTime: getCurrentTime(),
      showDialogTrancode: false,
      newTransactionCode: '',
      package_status: configs.PACKAGE_STATUS,
    };
  },
  props: ["dialogPackageDetail", "readOnly"],
  watch: {
    pagination: {
      handler: function(val, oldVal) {
        this.refreshData();
      },
      deep: true
    },
    packageId() {
      if(this.packageId > 0) {
        this.$router.push({
        name: "StoreManagerVNDetail",
        params: {
          Pid: this.packageId,
          title: "Chi tiết nhập kho"
        }
      });
      this.refreshData();
      }
      this.appLoading = false;
    }
  },
  computed: {
    ...mapState({
      currentItem: state => state.bigPackage.selected,
      totalPackage: state => {
        state.bigPackage.selected.Packages
          ? state.bigPackage.selected.Packages.length
          : 0;
      },
      loading: state => state.bigPackage.loading,
      trancodeDetail: state => state.bigPackage.trancodeDetail,
      packages: state => state.bigPackage.notTransit
    }),
    packageId() {
      return this.currentItem && this.currentItem.ID > 0
        ? this.currentItem.ID
        : Number(this.$route.params.Pid);
    },
    trancode_param() {
      let configPaging = _.cloneDeep(configs.PAGINATION);
      var param = {
        pagination: {
          ...configPaging,
          itemsPerPage: 1000000
        },
        'trancode': this.transactionCode
      };
      return param;
    }
  },
  mounted() {
    this.refreshData();
    this.getListPackageNotTran();
    this.$root.$emit("REQUEST_ROOT_OPTION", {});
    this.$root.$on("REQUEST_SAVE_DATA", this.dialogTrancode);
    this.$root.$on("REQUEST_CREATE_DATA", this.createData);
  },
  beforeDestroy() {
    this.$root.$off("REQUEST_SAVE_DATA", this.dialogTrancode);
    this.$root.$off("REQUEST_CREATE_DATA", this.createData);
  },
  methods: {
    display_color(val, enums) {
      return this.$options.filters.display_color(val, enums);
    },
    printTransaction(id, package_type) {
      request_detail('order_transactions/print', ret => {
          let item = ret.data;
          print_transaction_v2(item);
      }, Vue.http, id, this.$store.state.authentication.token, {'PackageType': package_type});
    },
    manualChanged() {
      if (!this.useBarcodeReader) {
        this.refreshData();
      }
    },
    codeChanged() {
      if (this.useBarcodeReader) {
        this.refreshData();
      }
    },
    refreshData() {
      if (this.packageId) {
        this.$store.dispatch("bigPackage/getDetail", {'id': this.packageId, 'param': this.trancode_param}).then(p => {
          if(this.transactionCode) {
            if(p.Packages[0].Weight && p.Packages[0].Status < 5 && this.markStorage) {
              this.$store.dispatch("orderTransaction/setDetail", {'data': {'Status': 4}, 'id': p.Packages[0].ID});
              p.Packages[0].Status = 4;
            }
          }
          else {
            this.$nextTick(() => this.$refs.trancode.focus());
          }
        });
      }
    },
    onChangePackage(value) {
      this.appLoading = true;
      let selectedItem = _.find(this.packages, { ID: value });
      if (selectedItem) {
        this.currentItem.PackageCode = selectedItem.PackageCode;
      }
      this.saveData();
    },
    getListPackageNotTran() {
      this.$store.dispatch("bigPackage/getListNotTransit");
    },
    saveTranWeight(item) {
      this.editTransCode(item);
    },
    saveNoteItem(item) {
      this.$store.dispatch("orderTransaction/setDetail", {'data': {'StoreVNNote': item.StoreVNNote}, 'id': item.ID});
    },
    createData(username = "") {
      this.getListPackageNotTran();
      this.$store.commit("bigPackage/setDetail", {
        data: {
          ID: 0,
          PackageCode: '',
          Weight: 0,
          Volume: 0,
          Amount: 0
        }
      });
      this.$router.push({
          name: "StoreManagerVNDetail",
          params: {
          Pid: 'nhap-bao-moi',
          title: 'Nhập bao mới'
          }
      });
    },
    saveData() {
      this.$store.dispatch("bigPackage/setDetail", {
        data: {
          ReceivedWeight: this.currentItem.ReceivedWeight,
          RealWeight: this.currentItem.RealWeight,
          ReceivedPacks: this.currentItem.ReceivedPacks,
          Status: configs.BIG_PACKAGE_STATUS_ENUM.NHAP_KHO_VN
        },
        id: this.currentItem.ID
      });
      this.appLoading = false;
    },
    editTransCode: _.debounce(
      function(item) {
        var data = {
          ID: item.ID,
          OrderID: item.OrderID,
          PackageType: item.PackageType,
          RealNumberOfPack: item.RealNumberOfPack,
          Weight: item.Weight,
          Volume: item.Volume,
          BigPackageId: item.BigPackageId,
          TransactionView: 'store_vn'
        };
        data.ModifiedBy = this.$store.state.authentication.user.username;
        this.$store.dispatch("orderTransaction/setDetail", { 'data': data, 'id': item.ID, 'param':  this.trancode_param});
      },
      500,
      {
        leading: false,
        trailing: true
      }
    ),
    dialogTrancode() {
      this.showDialogTrancode = true;
    },
    saveNewTrancode(isCloseDialog = true) {
      if(this.newTransactionCode != '') {
        this.$store.dispatch("bigPackage/addNewTrancode", {'tran_code': this.newTransactionCode, 'package_id': this.packageId, 'param': this.trancode_param});
        this.newTransactionCode = '';
      }
      this.showDialogTrancode = !isCloseDialog;
    }
  }
};
</script>
